import {
  BupSpinner,
  CourseTable,
  PageLayout,
  // Kpi,
  WorkGroupsContainer,
  WorkingMessage,
} from '@BUP/components';
import { Col, Row } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faProjectDiagram,
  faUsersCog,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import React, { useContext, useEffect } from 'react';
import { DashboardSociogramContext } from '@BUP/contexts';
import {
  useAuth,
  useGetDashboardResponses,
  useGetSurveysSociogram,
} from '@BUP/hooks';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import styles from './course.module.css';

const CourseView = () => {
  const { user } = useAuth();
  const [t] = useTranslation();
  const { sociogram, isLoadingSurveySociogram } = useGetSurveysSociogram(user);
  const { organizationResults } = useGetDashboardResponses(sociogram);
  const { filterCourse, course } = useContext(DashboardSociogramContext);
  const { courseId } = useParams();

  useEffect(() => {
    if (organizationResults) {
      filterCourse(organizationResults, courseId);
    }
  }, [organizationResults, courseId]);

  return (
    <>
      {isLoadingSurveySociogram ||
      !sociogram ||
      !course ||
      organizationResults === [] ? (
        <BupSpinner size="large" />
      ) : (
        <PageLayout
          pageName={`${t('pages.data.dashBoardSociogram.courseTitle')} ${
            course?.course?.name
          }`}
          backButton
        >
          <Row className={styles.title_container}>
            <Col>
              <div className={styles.students_icon_wrapper}>
                <FontAwesomeIcon
                  className={styles.icon_students}
                  icon={faUsers}
                />
              </div>
            </Col>
            <Col>
              <h1 className={styles.network_title}>
                {t('pages.data.dashBoardSociogram.tableTitle')}
              </h1>
            </Col>
          </Row>
          <Row gutter={[0, 48]} className={styles.students_container}>
            <Col span={24}>
              {/* <h1 className={styles.title}>Estudiantes</h1> */}
              <CourseTable data={course} />
            </Col>
          </Row>
          <Row className={styles.title_container}>
            <Col>
              <div className={styles.tools_icon_wrapper}>
                <FontAwesomeIcon
                  className={styles.icon_tools}
                  icon={faUsersCog}
                />
              </div>
            </Col>
            <Col>
              <h1 className={styles.network_title}>
                {t('pages.data.dashBoardSociogram.toolTitle')}
              </h1>
              <h2 className={styles.title}>
                {' '}
                {t('pages.data.dashBoardSociogram.toolSubTitle')}
              </h2>
            </Col>
          </Row>
          <Row>
            <WorkGroupsContainer
              groupPartition2={course?.groupPartition2}
              groupPartition3={course?.groupPartition3}
              groupPartition4={course?.groupPartition4}
            />
          </Row>
          <Row className={styles.title_container}>
            <Col>
              <div className={styles.network_icon_wrapper}>
                <FontAwesomeIcon
                  className={styles.icon_network}
                  icon={faProjectDiagram}
                />
              </div>
            </Col>
            <Col>
              <h1 className={styles.network_title}>
                {t('pages.data.dashBoardSociogram.graphTitle')}
              </h1>
            </Col>
          </Row>

          <Row type="flex" justify="center">
            <Col className={styles.working_wrapper}>
              <WorkingMessage
                message={t('pages.data.dashBoardSociogram.workingMessage')}
              />
            </Col>
          </Row>

          {/* Indicadores */}
          {/* <Row>
        <Col span={24}>
          <h1 className={styles.title}>Indicadores</h1>
          <Kpi
            bullyingCases={course?.bullyingCases}
            exclusionCases={course?.exclusionCases}
            conflictLevel={course?.conflictLevel}
            groupCohesion={course?.groupCohesion}
            groupSeggregation={course?.groupSeggregation}
          />
        </Col>
      </Row> */}
        </PageLayout>
      )}
    </>
  );
};

export default CourseView;
